import { useLocation } from 'react-router';
import { amuiUrl } from './carrotUrls';

export function useCurrentUrl() {
  const { pathname, search } = useLocation();
  return amuiUrl + pathname + search;
}
